import { styled } from "@mui/material/styles";
import ApexChart from "react-apexcharts";

const Chart = styled(ApexChart)``;

export default Chart;
